import {useAccount} from "../../accounts/hooks/useAccount.ts";
import {
    useAppDispatch,
    useAppSelector
} from "../../../hooks/useTypedReactRedux.ts";
import {Credentials} from "../types.ts";
import {forcePasswordChangeSelector} from "../selectors.ts";
import {signIn} from "../reducers/recordsSlice.ts";
import {useNavigate, useParams} from "react-router-dom";

export const useCredentials = () => {

    const {account: accountId} = useParams();
    const navigate = useNavigate();

    const {
        record: account,
    } = useAccount(accountId);

    const dispatch = useAppDispatch();

    const forcePasswordChange = useAppSelector((state) =>
                                                   forcePasswordChangeSelector(state)
    );


    const handleSignIn = async (values: Credentials) => {

        const result = await dispatch(
            signIn({
                       account: account,
                       username: account['emailAddress'] as string,
                       password: values.password as string,
                   })
        );

        if (signIn.fulfilled.match(result) && typeof result.payload !== 'undefined') {
            if (result.payload.challengeName !== 'NEW_PASSWORD_REQUIRED') {
                navigate(`/accounts/${accountId}/redirect`);
            }
        }

    }

    return {
        handleSignIn,
        forcePasswordChange,
    }
}